'use strict';

function OverlaySelectorDirective () {

  var link = function () {};

  return {
    bindToController: true,
    controller: 'OverlaySelectorController',
    controllerAs: 'overlaySelectorCtrl',
    link: link,
    templateUrl: 'dash/overlaySelector/overlaySelector.tpl.html'
  };
}

OverlaySelectorDirective.$inject = [];
module.exports = OverlaySelectorDirective;


// WEBPACK FOOTER //
// ./src/app/dash/overlaySelector/OverlaySelectorDirective.js